/* eslint react/prop-types: 0 */

import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { PDFPreview } from "../../component/pdfView";
import moment from "moment-timezone";

export default () => {
  const [selectedDoc, setSelectedDoc] = React.useState({});
  const [openPDF, setOpenPDF] = React.useState(false);
  const { dataReport, isLoading } = useSelector((state) => state.reportReducer);
  const filter = useSelector((state) => state.main);
  const data = dataReport?.content;
  if (data === undefined) return <div />;

  const previewPDF = (e, d) => {
    e.preventDefault();
    setOpenPDF(true);
    setSelectedDoc(d);
  };

  const getList = (type) => {
    const dt = data.filter((d) => d.type === type);
    if (dt.length === 0)
      return <small className="text-muted">(tidak ada dokumen)</small>;
    return (
      <ul>
        {dt.map((d, i) => (
          <li key={i}>
            <a href="#" onClick={(e) => previewPDF(e, d)}>
              {d.name || d.id}
            </a> <span> di-<em>upload</em> : { d.createdAt ? moment(d.createdAt).format("DD MMMM YYYY") : ""} </span>
          </li>
        ))}
      </ul>
    );
  };
  if (isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <h3 className="mb-4">
        Dokumen Laporan - {filter.labelMonth} {filter.yearFilter}
      </h3>
      <hr />
      <h5>Laporan Keuangan</h5>
      {getList(1)}
      <hr />
      <h5>Laporan Kinerja</h5>
      {getList(2)}
      <hr />
      <h5>Laporan Lainnya</h5>
      {getList(3)}
      <Modal isOpen={openPDF} toggle={() => setOpenPDF(!openPDF)} size="lg">
        <ModalHeader toggle={() => setOpenPDF(!openPDF)}>
          {selectedDoc.name}
        </ModalHeader>
        <ModalBody style={{ "max-height": "calc(100vh - 210px)" }}>
          <PDFPreview doc={selectedDoc} />
        </ModalBody>
      </Modal>
    </>
  );
};
